import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Progress
} from 'semantic-ui-react';
import {api} from '../../api';
import Dls from "../../lib";

class FileUploadButton extends Component {
    constructor() {
        super();
        this.state = {
            uploading: false
        }
    }
    //access router
    //this.props.history.push('/dashboard')
    handleUploadFile = (event) => {
        this.setState({
            uploading: true
        });
        const data = new FormData();
        data.append('file', event.target.files[0]);
        api.ecommerce.uploadNewFile(this.props.jwt, data).then(res => {
            this.setState({
                uploading: false
            });
            this.props.onSuccess(res.data.data);
        }).catch(err => {
            this.setState({
                loading: false
            })
            Dls.apiErrorAlert(err);
        });
    }

    render() {
        const {uploading} = this.state;
        if (uploading) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <Progress percent={100} active size='tiny' />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="row">
                    <div className="lara-upload-btn-wrapper">
                        <button className="lara-upload-btn">{this.props.name}</button>
                        <input type="file" name="myfile" onChange={this.handleUploadFile}/>
                    </div>
                </div>
                
            )
        }
    }
}

FileUploadButton.propTypes = {
    name: PropTypes.string.isRequired,
    jwt: PropTypes.string,
    onSuccess: PropTypes.func.isRequired
};


export default FileUploadButton;


// WEBPACK FOOTER //
// ./src/components/ecommerce/FileUploadButton.js